export default {
  methods: {
    async simpleCopy(text) {
      await navigator.clipboard.writeText(text);
    }
  }
}